import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { SecurityLayerService } from 'src/app/___LOGIC/__auth/security-layer.service';
import { NavigationService } from 'src/app/___LOGIC/__navigation/navigation.service';


interface HealthInsuranceRequest {
  startDate: Date;
  endDate: Date;
  passportPhoto: File;
  admissionLetter: File;
}

@Component({
  selector: 'app-health-helper',
  templateUrl: './health-helper.component.html',
  styleUrls: ['./health-helper.component.css']
})
export class HealthHelperComponent implements OnInit,AfterViewInit {
  healthInsuranceRequest: HealthInsuranceRequest = {
    startDate: new Date(),
    endDate: new Date(),
    passportPhoto: null,
    admissionLetter: null
  };


  centrosMedicos = {
    title: 'Centros médicos',
    subtitle: '¿Cómo puedo buscar un médico en la Web de ASISA?',
    imageUrl: this.guiFlow.getImage('e359d7e8-93f6-4b09-0d97-0c1983962d00','userApp'),
    longPar: '',
    description: '',
    longParLimit: '',
    shortPara: '',
    array: [
      {
        text: 'Accede a la Web de ASISA y selecciona la pestaña CUADRO MÉDICO que encontrarás en la parte superior de la página principal y te llevaremos al buscador ONLINE de Profesionales sanitarios y Centros concertados de todo el territorio nacional, que está permanentemente actualizado.',
      },
      {
        text: 'A continuación, utiliza los filtros disponibles para afinar tu búsqueda y cumplimenta los campos que te mostramos: Lugar: Calle, CP, población o provincia.',
      },
      {
        text: 'Puedes indicar que busque en el entorno de tu ubicación. Servicio: Especialidad médica, prueba diagnóstica o tratamiento que te han prescrito. Hospital, Centro Médico o Profesional: si no tienes ninguna referencia, puedes dejarlo en blanco.',
      },
      {
        text: 'Haz clic en BUSCAR y te mostraremos los resultados. Encontrarás toda la información disponible para llamar y concertar una cita, o para desplazarte hasta el lugar, ya que podrás ver en el mapa la ubicación de los resultados de tu búsqueda. ',
      },
      {
        text: 'Para una nueva búsqueda, haz clic en BORRAR FILTROS y vuelve a teclear los parámetros de tu interés.',
      },
      {
        text: 'Además, desde el buscador ON LINE de Profesionales sanitarios y Centros tienes la opción de descargar y guardar en formato PDF el Cuadro médico de tu provincia, que podrás imprimir en papel si lo deseas.',
      },
      {
        text: 'Para ello, elige la opción "Descargar PDF online" de la parte inferior de tu pantalla. Selecciona la provincia, teclea el municipio y elige TODAS las especialidades médicas.',
      }
    ]
  };

  atencionSanitaria = {
    cardId: 'Icon',
    title: 'Atención sanitaria en España',
    subtitle: '',
    categories: [ 'Salud', 'Seguridad Social', 'España' ],
    imageUrl: this.guiFlow.getImage('0539da1d-067c-4845-c711-9db70b7e9500','public'),
    // Photo by <a href="https://unsplash.com/@bermixstudio?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Bermix Studio</a> on <a href="https://unsplash.com/photos/a-woman-in-a-white-shirt-holding-a-red-ribbon-Gg6OrxUotLQ?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
    longPar: 'El sistema de salud español, reconocido por su calidad y accesibilidad, se basa en la sanidad pública financiada por el Estado, garantizando cobertura universal y gratuita a todos los residentes. Incluye atención primaria, especializada y urgencias, con énfasis en la prevención y el bienestar. La gestión se realiza a nivel nacional y autonómico, asegurando servicios eficientes y equitativos en todo el país.',
    longParLimit: '280',
    shortPara: '',
    iconSize: 'md',
    buttonText: 'Button',
    paragraphsWithIcons: true,
    array: [
      {
        title: 'Seguridad social',
        description: 'Sistema de salud en España: España cuenta con un sistema de salud público de alta calidad llamado Sistema Nacional de Salud (SNS). Además, existen también compañías de seguros privados que ofrecen cobertura adicional.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-hospital'
      },
      {
        title: 'Seguros médicos',
        description: 'Seguro médico obligatorio para estudiantes extranjeros: Algunas universidades o instituciones educativas pueden requerir que los estudiantes extranjeros cuenten con un seguro médico específico para poder matricularse. Asegúrate de verificar los requisitos de tu institución y cumplir con ellos.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-file-medical'
      },
      {
        title: 'Farmacias',
        description: 'En España, las farmacias son muy accesibles y desempeñan un papel importante en la atención médica. Puedes adquirir medicamentos sin necesidad de receta médica en las farmacias, pero si requieres medicamentos recetados, deberás acudir a un médico.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-user-md'
      },
      {
        title: 'Urgencias médicas',
        description: 'En caso de emergencia médica, puedes llamar al número de teléfono gratuito 112. También puedes acudir directamente a un servicio de urgencias hospitalario (Servicio de Urgencias de un hospital) para recibir atención inmediata.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-ambulance'
      },
      {
        title: 'Centros de atención primaria',
        description: 'Una vez que estés en Madrid, puedes acudir a un centro de atención primaria (Centro de Salud) para recibir atención médica básica. Allí podrás consultar a médicos generales, obtener recetas médicas y ser derivado a especialistas si es necesario. Encuentra el centro de salud más cercano a tu lugar de residencia y regístrate como paciente.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-clinic-medical'
      },
      {
        title: 'Documentos necesarios',
        description: 'Es importante llevar contigo siempre tu documento de identificación (DNI, pasaporte) y tu tarjeta sanitaria (TSE o seguro médico privado). Estos documentos te serán solicitados en el momento de recibir atención médica.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-id-card-alt'
      },
      {
        title: 'Extranjeros sin seguro médico',
        description: 'Si por alguna razón te encuentras en España sin seguro médico y necesitas atención médica, aún puedes acudir a un centro de atención primaria o a un servicio de urgencias hospitalario. En caso de no contar con recursos económicos, existen programas de asistencia sanitaria para personas en situación de vulnerabilidad. Infórmate en el centro de salud más cercano.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-id-card-alt'
      },
      {
        title: 'Tarjeta Sanitaria Europea (TSE)',
        description: 'Si eres ciudadano de un país miembro de la Unión Europea (UE), es recomendable solicitar la Tarjeta Sanitaria Europea en tu país de origen antes de viajar a España. Esta tarjeta te dará acceso a la atención médica en el sistema público español durante tu estancia.',
        imageUrl: '../../assets/voyjaleas/userApp/extranjeria/renovacion/nieRenov.png',
        icon: 'fas fa-hospital-symbol'
      },
    ]
  };

  comoUsarMiSeguro = {
    cardId: 'B',
    imageUrl: this.guiFlow.getImage('ac4fa934-80ef-4090-8b69-78c82c96c900','userApp'),
    title: '¿Cómo utilizar tu seguro médico?',
    subtitle: 'En caso de un accidente, ¿A quién tenés que llamar? ¿A cuál hospital debo ir para que cubra mi seguro?',
    description: 'Ante una urgencia médica: ',
    longPar: 'Te darán instrucciones sobre qué hacer en tu caso concreto y resolverán tu necesidad de la forma más adecuada: Enviarán un médico o un profesional de enfermería a tu domicilio. Gestionarán un traslado en ambulancia, en los casos necesarios. Te indicarán dónde puedes acudir para ser atendido. Como sugerencia, graba este número de teléfono en la memoria de tu móvil como: AA ASISA URGENCIAS. Para ganar tiempo, puedes llamar desde la App de ASISA, pulsando el botón rojo que verás en la pantalla principal de la App.',
    longParLimit: '180',
    shortPara: '',
    info: 'Llama a ASISA URGENCIAS: 900 900 118. \n Si llamas desde Barcelona, debes marcar el 93 253 38 98 y si llamas desde Girona, el 972 93 23 98.'
  };

  comoRellenarFormulario = {
    title: '¿Cómo rellenar el formulario?',
    subtitle: 'Indicaciones para rellenar el formulario',
    array: [
      {
        title: 'Formulario de solicitud del seguro médico',
        text: ''
      },
      {
        title: 'Rellenar el formulario de Salud',
        text: ''
      },
      {
        title: 'NIF/NIE : Ingresar el número de Pasaporte',
        text: ''
      },
      {
        title: 'Talla: estatura en centímetros',
        text: ''
      }
    ]
  }

  userHasInssurance = false;
  info = {
    startDate: null,
    endDate: null
  };
  loading = false;

  @ViewChild('intro') intro: ElementRef<HTMLDivElement>;
  @ViewChild('sistema') sistema: ElementRef<HTMLDivElement>;
  @ViewChild('contratar') contratar: ElementRef<HTMLDivElement>;
  @ViewChild('form') form: ElementRef<HTMLDivElement>;
  @ViewChild('how') how: ElementRef<HTMLDivElement>;
  @ViewChild('centros') centros: ElementRef<HTMLDivElement>;

  @ViewChild('solicitarInfoSeguro') step10: ElementRef;

  sections = [
    { id: 'intro', title: 'Introducción', content: 'Content for Section 1...', visible: true },
    { id: 'sistema', title: 'Sistema de salud en España', content: 'Content for Section 1...', visible: true },
    { id: 'contratar', title: 'Contratar seguro médico', content: 'Content for Section 2...', visible: true },
    { id: 'form', title: '¿Cómo rellenar el formulario del seguro médico?', content: 'Content for Section 3...', visible: true },
    { id: 'how', title: '¿Cómo utilzar tu seguro médico?', content: 'Content for Section 3...', visible: true },
    { id: 'centros', title: 'Centros médicos', content: 'Content for Section 3...', visible: true }
  ];

  constructor(private guiFlow: GuiFlowService,private apiConnector: ApiConnectorService,private router: Router,private securityLayer: SecurityLayerService,private resolver: ResolverService,private route: ActivatedRoute,private navigationService: NavigationService) { }

  ngOnInit(): void {
    const currentClientId: number = this.resolver.getSelectedClientId() ?? 0;
    const myString: string = currentClientId.toString(); 
    if(currentClientId){
      // hay cliente logueado
      //prregunto si tiene contrato
      this.loading = true;
      this.apiConnector.getQueryResult('getClientOmnibusContract', {
        queryParam1: '181' //myString
      }).subscribe(
        (response: any) => {
          console.log('Success:', response);
        },
        (error) => {
          console.error('Error:', error);
        }
      );
    }else{
      this.loading = false;
      this.userHasInssurance = false;
      // TO REFACTOR
      this.sections[3].visible = false;
      !this.userHasInssurance? this.sections[4].visible = false : null;
      !this.userHasInssurance? this.sections[5].visible = false : null;
    }

  }

  ngAfterViewInit() {
    // Map fragments to ViewChild elements
    const sectionMap: { [key: string]: ElementRef<HTMLDivElement> } = {
      intro: this.intro,
      sistema: this.sistema,
      contratar: this.contratar,
      form: this.form,
      how: this.how,
      centros: this.centros,
      /* solicitarInfoSeguro: this.solicitarInfoSeguro */
    };

    // Call the shared service to handle scrolling
    this.navigationService.scrollToFragment(this.route, sectionMap);
  }

  isSectionVisible(id: string): boolean {
    const section = this.sections.find(section => section.id === id);
    return section?.visible ?? false;
  }
  isCardVisible(cardId){
    switch(cardId){
      case 'contratarSeguroGetInfo':
        return !this.userHasInssurance;
    }
  }
  
  saveDataToLocalClass1(res){
    if(res.records && res.records[0]){
      this.info = res.records[0];
      this.userHasInssurance = true;
    }else{
      this.userHasInssurance = false;
    }
  }

  getImageSize(cardData){
    switch(cardData.imageSize){
      case 'sm':
        return 'image-cnt-sm rounded-border';
      case 'md':
        return 'image-cnt-md rounded-border'
      case 'lg':
        return 'image-cnt-lg rounded-border'
      default:
        return 'image-cnt-sm'
    }
  }

  getItemClass(cardData,item){
    switch(cardData.iconSize){
      case 'sm':
        return 'icon-sm';
      case 'md':
        return item.icon + ' icon-med'
      case 'lg':
        return item.icon + ' icon-med'
      default:
        return item.icon + ' icon-sm'
    }
  }
  getImageUrl(url){
    return this.guiFlow.getImage(url,'public')
  }

  openPdfModal(pdfId){
    this.router.navigateByUrl('pdf-view/'+pdfId);
  }

  goToLink(link){
    window.open(link, '_blank');
  }

  scrollIntoView(selection): void {
    switch(selection){
      case 'intro':
        this.intro.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'sistema':
        this.sistema.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
/*       case 'solicitarInfoSeguro':
        this.solicitarInfoSeguro.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break; */
      case 'contratar':
          this.contratar.nativeElement.scrollIntoView({ behavior: 'smooth'});
          break;
      case 'form':
        this.form.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'how':
        this.how.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
      case 'centros':
        this.centros.nativeElement.scrollIntoView({ behavior: 'smooth'});
        break;
    }
  }

  openAsisaForm(){
    this.openPdfModal('formularioAsisa');
  }

  openAsisaQ(){
    this.openPdfModal('cuestionarioAsisa');
  }

  isHealthFormFilled(){
    return true;
    /* return this.resolver.getDependencyRecords('getUserHealthForm').length>0; */
  }

  goToForm(){

  }

}
